import { customContextFactory } from '../../../../../../hooks/custom-context-factory';
import { useScheduleRequestDetails } from '../hooks/use-schedule-request-details';

type ContextType = Omit<ReturnType<typeof useScheduleRequestDetails>, 'providerValue'>;

export const [ScheduleRequestDetailsContextProvider, useScheduleRequestDetailsContext] =
  customContextFactory<ContextType>();
